import type { Campaign } from 'src/common/interfaces/campaigns';

export const useGetAfterSignupFlashSaleEndTime = (campaign: Campaign | null, dateSignUp?: string) => {
  if (!campaign) return undefined;

  const { daysPassedSinceSignUp = 0, campaignLifeTimeDays = 0 } = campaign.flashSale ?? {};
  const userSignUpDate = new Date(dateSignUp ?? Date.now());

  const totalDaysUntilEnd = daysPassedSinceSignUp + campaignLifeTimeDays;
  const endTime = new Date(userSignUpDate.getTime() + totalDaysUntilEnd * 24 * 60 * 60 * 1000);

  return endTime.getTime();
};
